export default __webpack_public_path__ + "static/media/Group19.a8058a90.png";